import { Scene, Input } from "phaser";
import FullScreen from "../../phaser/components/fullScreen";


export default class Credits extends Scene {


    constructor() {
        super({ key: "Credits" });
    }
    init() {
    }

    preload() {
    
        if (this.sys.game.device.os.desktop) {
            this.isMobile = false;
        }
        else {
            this.isMobile = true;
        }


    }
    create() {
        this.spaceBar = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.SPACE);
        this.buttonFullscreen = new FullScreen(this);
        this.screenCenterX = this.cameras.main.worldView.x + this.cameras.main.width / 2;
        this.screenCenterY = this.cameras.main.worldView.y + this.cameras.main.height / 2;
        const content = [
            "INSOMNIA",
            "Thank you for being our REASON",
            "Thanks for playing"
        ];
        
        this.background = this.add.image((this.screenCenterX / 2) , (this.screenCenterY/ 2) - 115, `background-buttons-win`).setScale(0.5).setOrigin(0,0).setScrollFactor(0);
        this.text = this.add.text(this.screenCenterX - 5, this.screenCenterY - 110, content, { font: "25px CustomFont", fill: "#FFFFFF" }).setOrigin(0.5);
        // this.background = this.add.image((this.screenCenterX / 2) + 110, (this.screenCenterY/ 2) + 100, `background-buttons-win`).setScale(0.2).setOrigin(0,0).setScrollFactor(0);

        const levels = localStorage.getItem('noL');

        const levelsArray = JSON.parse(levels);        
        
        this.restart = this.add.image((this.screenCenterX / 2) + 135, (this.screenCenterY/ 2) + 140, `button1-win`).setScale(0.2).setOrigin(0,0).setScrollFactor(0).setInteractive({ useHandCursor: true });
        if(levelsArray && levelsArray.length === 12) {
            this.video =  this.add.image((this.screenCenterX / 2) + 135, (this.screenCenterY/ 2) + 210, `button2-win`).setScale(0.2).setOrigin(0,0).setScrollFactor(0).setInteractive({ useHandCursor: true });
        }


        this.restart.on('pointerdown', () => {
            this.restart.setAlpha(0.4)
        }).on('pointerup', () => {
            this.restart.setAlpha(1)
            this.goToGame()
        });

        if(this.video) {
            this.video.on('pointerdown', () => {
                this.video.setAlpha(0.4)
            }).on('pointerup', () => {
                this.video.setAlpha(1)
                this.handleVideo()
            });
        }

    }

    goToGame() {
        localStorage.clear();
        this.scene.start(`Start`);
        window.location.reload();
    }

    handleVideo() {

        window.open('https://www.youtube.com/embed/n30xOgXSSsA?autoplay=1', '_blank');

        // this.load.html('youtube', `
        //     <div class="video-container">
        //       <iframe 
        //         id="youtube-iframe"
        //         src="https://www.youtube.com/embed/n30xOgXSSsA?autoplay=1" 
        //         frameborder="0" 
        //         allow="autoplay; fullscreen"
        //         allowfullscreen>
        //       </iframe>
        //     </div>
        //   `);

        //   this.add.dom(window.innerWidth / 2, window.innerHeight / 2)
        //   .createFromCache('youtube');
  
        // // Ajustar estilos del iframe después de que se haya insertado en el DOM
        // const iframe = document.getElementById('youtube-iframe');
        // if (iframe) {
        //   iframe.style.width = '100vw';
        //   iframe.style.height = '100vh';
        // // }
        // this.youtubePlayer = this.add.rexYoutubePlayer(this.screenCenterX, this.screenCenterY, this.cameras.main.worldView.width, this.cameras.main.worldView.height, {
        //     x: this.screenCenterX,
        //     y: this.screenCenterY,
        //     width: this.cameras.main.worldView.width,
        //     height: this.cameras.main.worldView.height,
        //     videoId: 'n30xOgXSSsA',
        //     autoPlay: true,
        //     controls: false,
        //     keyboardControl: false,
        //     modestBranding: false,
        //     loop: false,
        // });

        // this.youtubePlayer.setVisible(true);
        // this.youtubePlayer.setDepth(1000);

        
    }

    
    update() {


    }


}